import { useContext } from 'react';
import { CreditContext } from '../context/creditContext';
import miscApi from '../apis/misc';
import { useQuery } from 'react-query';

const useCreditContext = () => {
  return useContext(CreditContext);
};

export default useCreditContext;

const { getCreditsAvailable, getCreditUsageData } = miscApi;

export const useGetCreditsAvailable = (
  isAuthenticated,
  token,
  onSuccess,
  onError
) =>
  useQuery(['credits_available'], () => getCreditsAvailable(), {
    enabled: !!isAuthenticated && !!token,
    onSuccess,
    onError,
  });
export const useGetAllCreditUsageData = (
  fromDate,
  toDate,
  onSuccess,
  onError
) =>
  useQuery(['', fromDate, toDate], () => getCreditUsageData(fromDate, toDate), {
    onSuccess,
    onError,
  });
